import Skill from "../../components/skill";

export default function Skills() {
    return (
      <div className="w-11/12 max-w-7xl mx-auto">
        <Skill />
      </div>
    )
};
